// extracted by mini-css-extract-plugin
export default {"p_tye":"db203a5d6b","slcted":"_08fc50986d","slc_color":"_56923528c9","item_p":"_06f8adb708","r0":"_209bbd49f9"};